export const employeesColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Operating revenue (Turnover)",
    field: "operating_revenue_turnover"
  },
  {
    label: "P/L before tax",
    field: "p_l_before_tax"
  },
  {
    label: "P/L for period [=Net income]",
    field: "p_l_for_period_net_income"
  },
  {
    label: "Cash flow",
    field: "cash_flow"
  },
  {
    label: "Total assets",
    field: "total_assets"
  },
  {
    label: "Shareholders funds",
    field: "shareholders_funds"
  },

  {
    label: "Current ratio (x)",
    field: "current_ratio"
  },
  {
    label: "Profit margin (%)",
    field: "profit_margin"
  },
  {
    label: "ROE using P/L before tax (%)",
    field: "roe_using_p_l_before_tax"
  },
  {
    label: "ROCE using P/L before tax (%)",
    field: "roce_using_p_l_before_tax"
  },
  {
    label: "Solvency ratio (Asset based) (%)",
    field: "solvency_ratio_asset_based"
  },
  {
    label: "Number of employees",
    field: "number_of_employees"
  }
]

export const keyFinancialsColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "NAV per Share",
    field: "nav_per_share"
  },
  {
    label: "EPS",
    field: "eps"
  },
  {
    label: "Capital Reserve per Share",
    field: "capital_reserve_per_share"
  },
  {
    label: "Return on Equity (ROE)",
    field: "return_on_equity_roe"
  },
  {
    label: "Total Assets Growth Rate",
    field: "total_assets_growth_rate"
  },
  {
    label: "Net Profit Growth Rate",
    field: "net_profit_growth_rate"
  }
]

// 普通公司
export const globalAssetsColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Fixed assets",
    field: "fixed_assets"
  },
  {
    label: "Intangible fixed assets",
    field: "intangible_fixed_assets"
  },
  {
    label: "Tangible fixed assets",
    field: "tangible_fixed_assets"
  },
  {
    label: "Other fixed assets",
    field: "other_fixed_assets"
  },
  {
    label: "Current assets",
    field: "current_assets"
  },
  {
    label: "Stock",
    field: "stock"
  },

  {
    label: "Debtors",
    field: "debtors"
  },
  {
    label: "Other current assets",
    field: "other_current_assets"
  },
  {
    label: "Total assets",
    field: "total_assets"
  }
]

export const equityColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Shareholders funds",
    field: "shareholders_funds"
  },
  {
    label: "Capital",
    field: "capital"
  },
  {
    label: "Other shareholders funds",
    field: "other_shareholders_funds"
  },
  {
    label: "Non-current liabilities",
    field: "non_current_liabilities"
  },
  {
    label: "Long term debt",
    field: "long_term_debt"
  },
  {
    label: "Other non-current liabilities",
    field: "other_non-current_liabilities"
  },
  {
    label: "Current liabilities",
    field: "current_liabilities"
  },
  {
    label: "Loans",
    field: "loans"
  },
  {
    label: "Creditors",
    field: "creditors"
  },
  {
    label: "Other current liabilities",
    field: "other_current_liabilities"
  },
  {
    label: "Total shareh. funds & liab.",
    field: "total_shareh_funds_liab"
  }
]


export const profitColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Operating revenue (Turnover)",
    field: "operating_revenue_turnover"
  },
  {
    label: "Costs of goods sold",
    field: "costs_of_goods_sold"
  },
  {
    label: "Gross profit",
    field: "gross_profit"
  },
  {
    label: "Other operating expenses",
    field: "other_operating_expenses"
  },
  {
    label: "Operating P/L [=EBIT]",
    field: "operating_p_l"
  },
  {
    label: "Financial P/L",
    field: "financial_p_l"
  },
  {
    label: "P/L before tax",
    field: "p_l_before_tax"
  },
  {
    label: "Taxation",
    field: "taxation"
  },
  {
    label: "P/L after tax",
    field: "p_l_after_tax"
  },
  {
    label: "Extr. and other P/L",
    field: "extr_and_other_p_l"
  },
  {
    label: "P/L for period [=Net income]",
    // field: "p_l_for_period_net_income"
    field: "p_l_for_period"
  }
]

export const memoColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Working capital",
    field: "working_capital"
  },
  {
    label: "Net current assets",
    field: "net_current_assets"
  },
  {
    label: "Enterprise value",
    field: "enterprise_value"
  },
  {
    label: "Number of employees",
    field: "number_of_employees"
  },
  {
    label: "Export revenue",
    field: "export_revenue"
  },
  {
    label: "Material costs",
    field: "material_costs"
  },
  {
    label: "Costs of employees",
    field: "costs_of_employees"
  },
  {
    label: "Depreciation & Amortization",
    field: "depreciation_amortization"
  },
  {
    label: "Other operating items",
    field: "other_operating_items"
  },
  {
    label: "Interest paid",
    field: "interest_paid"
  },
  {
    label: "Research & Development expenses",
    field: "research_development_expenses"
  },
  {
    label: "Cash flow",
    field: "cash_flow"
  },
  {
    label: "Added value",
    field: "added_value"
  },
  {
    label: "EBITDA",
    field: "ebitda"
  }
]
// 
// 银行
export const globalAssetsColumnYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Loans",
    field: "loans"
  },
  {
    label: "Gross loans",
    field: "gross_loans"
  },
  {
    label: "Less: reserves for impaired loans / NPLs",
    field: "less_reserves_for_impaired_loans_npls"
  },
  {
    label: "Other Earning Assets",
    field: "other_earning_assets"
  },
  {
    label: "Loans and advances to banks",
    field: "loans_and_advances_to_banks"
  },
  {
    label: "Derivatives (Assets)",
    field: "derivatives_assets"
  },

  {
    label: "Other securities",
    field: "other_securities"
  },
  {
    label: "Remaining earning assets",
    field: "remaining_earning_assets"
  },
  {
    label: "Total Earning Assets",
    field: "total_earning_assets"
  },
  {
    label: "Fixed Assets",
    field: "fixed_assets"
  },
  {
    label: "Non-Earning Assets",
    field: "non-earning_assets"
  },
  {
    label: "Total assets",
    field: "total_assets"
  }
]

export const equityColumnYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Deposits & short term funding",
    field: "deposits_short_term_funding"
  },
  {
    label: "Total customer deposits",
    field: "total_customer_deposits"
  },
  {
    label: "Deposits from banks",
    field: "deposits_from_banks"
  },
  {
    label: "Other deposits and short-term borrowings",
    field: "other_deposits_and_short-term_borrowings"
  },
  {
    label: "Other interest bearing liabilities",
    field: "other_interest_bearing_liabilities"
  },
  {
    label: "Derivatives (Liabilities and Equity)",
    field: "derivatives_liabilities_and_equity"
  },
  {
    label: "Trading liabilities",
    field: "trading_liabilities"
  },
  {
    label: "Long term funding",
    field: "long_term_funding"
  },
  {
    label: "Other (non-interest bearing)",
    field: "other_non-interest_bearing"
  },
  {
    label: "Loan Loss Reserves",
    field: "loan_loss_reserves"
  },
  {
    label: "Other Reserves",
    field: "other_reserves"
  },
  {
    label: "Equity",
    field: "equity"
  },
  {
    label: "Total Liabilities & Equity",
    field: "total_liabilities_equity"
  }
]


export const profitColumnYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Net Interest Revenue",
    field: "net_interest_revenue"
  },
  {
    label: "Interest Income",
    field: "interest_income"
  },
  {
    label: "Interest Expense",
    field: "interest_expense"
  },
  {
    label: "Other Operating Income",
    field: "other_operating_income"
  },
  {
    label: "Net gains (losses) on trading and derivatives",
    field: "net_gains_losses_on_trading_and_derivatives"
  },
  {
    label: "Net gains (losses) on assets at FV through income statement",
    field: "net_gains_losses_on_assets_at_fv_through_income_statement"
  },
  {
    label: "Net fees and commissions",
    field: "net_fees_and_commissions"
  },
  {
    label: "Remaining operating income",
    field: "remaining_operating_income"
  },
  {
    label: "Overheads",
    field: "overheads"
  },
  {
    label: "Loan Loss Provisions",
    field: "loan_loss_provisions"
  },
  {
    label: "Other",
    field: "other"
  },

  {
    label: "Profit before Tax",
    field: "profit_before_tax"
  },
  {
    label: "Tax",
    field: "tax"
  },
  {
    label: "Net Income",
    field: "net_income"
  },
  {
    label: "Operating Income (Memo)",
    field: "operating_income_memo"
  },
  {
    label: "Operating Income",
    field: "operating_income"
  }
]

export const memoColumnYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Total Capital Ratio (%)",
    field: "total_capital_ratio"
  },
  {
    label: "Tier 1 Ratio (%)",
    field: "tier_1_ratio"
  },
  {
    label: "Total Capital",
    field: "total_capital"
  },
  {
    label: "Tier 1 Capital",
    field: "tier_1_capital"
  },
]
// 

// 保险
export const globalAssetsColumnBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Total investments",
    field: "total_investments"
  },
  {
    label: "Total debtors",
    field: "total_debtors"
  },
  {
    label: "Assets (other)",
    field: "assets_other"
  },
  {
    label: "Total assets",
    field: "total_assets"
  }
]

export const equityColumnBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Capital & surplus",
    field: "capital_surplus"
  },
  {
    label: "Total gross provisions",
    field: "total_gross_provisions"
  },
  {
    label: "Total creditors",
    field: "total_creditors"
  },
  {
    label: "Liabilities (other)",
    field: "liabilities_other"
  },
  {
    label: "Total liabilities and surplus",
    field: "total_liabilities_and_surplus"
  }
]


export const profitColumnBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Gross premiums written",
    field: "gross_premiums_written"
  },
  {
    label: "Net premiums written",
    field: "net_premiums_written"
  },
  {
    label: "Earned premiums",
    field: "earned_premiums"
  },
  {
    label: "Total underwriting income",
    field: "total_underwriting_income"
  },
  {
    label: "Total underwriting expenses",
    field: "total_underwriting_expenses"
  },
  {
    label: "Balance on combined technical account",
    field: "balance_on_combined_technical_account"
  },
  {
    label: "Net investment income",
    field: "net_investment_income"
  },
  {
    label: "Profit/(loss) before tax",
    field: "profit_loss_before_tax"
  },
  {
    label: "Profit/(loss) after tax",
    field: "profit_loss_after_tax"
  },
  {
    label: "Ret profit/(loss) for the financial year",
    field: "ret_profit_loss_for_the_financial_year"
  }
]

export const memoColumnBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Gross premiums written",
    field: "gross_premiums_written"
  },
  {
    label: "Net premiums written",
    field: "net_premiums_written"
  },
  {
    label: "Earned premiums",
    field: "earned_premiums"
  },
  {
    label: "Total revenue",
    field: "total_revenue"
  },

  {
    label: "Total expenses",
    field: "total_expenses"
  },
  {
    label: "Balance on life technical account",
    field: "balance_on_life_technical_account"
  },
  {
    label: "Gross premiums written",
    field: "gross_premiums_written"
  },
  {
    label: "Net premiums written",
    field: "net_premiums_written"
  },
  {
    label: "Earned premiums",
    field: "earned_premiums"
  },
  {
    label: "Total underwriting expenses",
    field: "total_underwriting_expenses"
  },
  {
    label: "Balance on general technical account",
    field: "balance_on_general_technical_account"
  },
]
// 

export const incomeColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Operating Income",
    field: "operating_income"
  },
  {
    label: "Operating Cost",
    field: "operating_cost"
  },
  {
    label: "Operating Profit",
    field: "operating_profit"
  },
  {
    label: "Total Profit",
    field: "total_profit"
  },
  {
    label: "Income Tax",
    field: "income_tax"
  }
]

export const balanceColumn = [
  {
    label: "year",
    field: "year"
  },
  // {
  //   label: "Monetary Fund",
  //   field: "a"
  // },
  {
    label: "Current Assets",
    field: "current_assets"
  },
  {
    label: "Non-Current Assets",
    field: "non_current_assets"
  },
  {
    label: "Total Assets",
    field: "total_assets"
  },
  {
    label: "Current Liabilities",
    field: "current_liabilities"
  },
  {
    label: "Long-term Loans",
    field: "long_term_loans"
  },

  {
    label: "Total Non-current Liabilities",
    field: "total_non_current_liabilities"
  },
  {
    label: "Total Liabilities",
    field: "total_liabilities"
  },
  {
    label: "Company’s Total Share Capital",
    field: "companys_total_share_capital"
  },
  {
    label: "Retained Profit",
    field: "retained_profit"
  },
  {
    label: "Total Shareholders' Equity",
    field: "total_shareholders_equity"
  }
]

export const cashFlowColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Net Cash Flows from Operating Activities",
    field: "net_cash_flows_from_operating_activities"
  },
  {
    label: "Net Cash Flows From Investing Activities",
    field: "net_cash_flows_from_investing_activities"
  },
  {
    label: "Net Cash Flow From Financing Activities",
    field: "net_cash_flow_from_financing_activities"
  }
]


// 普通公司
export const profitabilityColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "ROE using P/L before tax (%)",
    field: "roe_using_pl_before_tax"
  },
  {
    label: "ROCE using P/L before tax (%)",
    field: "roce_using_pl_before_tax"
  },
  {
    label: "ROA using P/L before tax (%)",
    field: "roa_using_pl_before_tax"
  }, {
    label: "ROE using Net income (%)",
    field: "roe_using_net_income"
  },
  {
    label: "ROCE using Net income (%)",
    field: "roce_using_net_income"
  },
  {
    label: "ROA using Net income (%)",
    field: "roa_using_net_income"
  }, {
    label: "Profit margin (%)",
    field: "profit_margin"
  },
  {
    label: "Gross margin (%)",
    field: "gross_margin"
  },
  {
    label: "EBITDA margin (%)",
    field: "ebitda_margin"
  },

  {
    label: "EBIT margin (%)",
    field: "ebit_margin"
  }, {
    label: "Cash flow / Operating revenue (%)",
    field: "cash_flow_operating_revenue"
  },
  {
    label: "Enterprise value / EBITDA (x)",
    field: "enterprise_value_ebitda"
  },
  {
    label: "Market cap / Cash flow from operations (x)",
    field: "market_cap_cash_flow_from_operations"
  }
]

export const operationalColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Net assets turnover (x)",
    field: "net_assets_turnover"
  },
  {
    label: "Interest cover (x)",
    field: "interest_cover"
  },
  {
    label: "Stock turnover (x)",
    field: "stock_turnover"
  },
  {
    label: "Collection period (days)",
    field: "collection_period_days"
  },
  {
    label: "Credit period (days)",
    field: "credit_period_days"
  },
  {
    label: "Export revenue / Operating revenue (%)",
    field: "export_revenue_operating_revenue"
  },
  {
    label: "R&D expenses / Operating revenue (%)",
    field: "r_d_expenses_operating_revenue"
  }
]

export const structureColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Current ratio (x)",
    field: "current_ratio"
  },
  {
    label: "Liquidity ratio (x)",
    field: "liquidity_ratio"
  },
  {
    label: "Shareholders liquidity ratio (x)",
    field: "shareholders_liquidity_ratio"
  },
  {
    label: "Solvency ratio (Asset based) (%)",
    field: "solvency_ratio_asset_based"
  },
  {
    label: "Solvency ratio (Liability based) (%)",
    field: "solvency_ratio_liability_based"
  },
  {
    label: "Gearing (%)",
    field: "gearing"
  }
]

export const perEmployeeColumn = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Profit per employee (th)",
    field: "profit_per_employee"
  },
  {
    label: "Operating revenue per employee (th)",
    field: "operating_revenue_per_employee"
  },
  {
    label: "Costs of employees / Operating revenue (%)",
    field: "costs_of_employees_operating_revenue"
  },
  {
    label: "Average cost of employee (th)",
    field: "average_cost_of_employee"
  },
  {
    label: "Shareholders funds per employee (th)",
    field: "shareholders_funds_per_employee"
  },
  {
    label: "Working capital per employee (th)",
    field: "working_capital_per_employee"
  },
  {
    label: "Total assets per employee (th)",
    field: "total_assets_per_employee"
  }
]



// 银行公司
export const profitabilityColumnYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Loan Loss Res. / Gross Loans (%)",
    field: "loan_loss_res_gross_loans"
  },
  {
    label: "Loan Loss Prov. / Net Int. Rev. (%)",
    field: "loan_loss_prov_net_int_rev"
  },
  {
    label: "Loan Loss Res. / Non Perf. Loans (%)",
    field: "loan_loss_res_non_perf_loans"
  }, {
    label: "Non Perf. Loans / Gross Loans (%)",
    field: "non_perf_loans_gross_loans"
  },
  {
    label: "NCO / Average Gross Loan (%)",
    field: "nco_average_gross_loan"
  },
  {
    label: "NCO / Net Inc. bef. Ln Lss Prov. (%)",
    field: "nco_net_inc_bef_ln_lss_prov"
  }, {
    label: "Impaired loans / Equity (%)",
    field: "impaired_loans_equity"
  },
  {
    label: "Unreserved impaired loans / Equity (%)",
    field: "unreserved_impaired_loans_equity"
  }
]

export const CapitalRatiosYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Tier 1 Ratio (%)",
    field: "tier_1_ratio"
  },
  {
    label: "Total Capital Ratio (%)",
    field: "total_capital_ratio" 
  },
  {
    label: "Equity / Total assets (%)",
    field: "equity_total_assets"
  },
  {
    label: "Equity / Net Loans (%)",
    field: "equity_net_loans"
  },
  {
    label: "Equity / Dep. & ST Funding (%)",
    field: "equity_dep_st_funding"
  },
  {
    label: "Equity / Liabilities (%)",
    field: "equity_liabilities"
  },
  {
    label: "Cap. Funds / Total assets (%)",
    field: "cap_funds_total_assets"
  },

  {
    label: "Cap. Funds / Net Loans (%)",
    field: "cap_funds_net_loans"
  },
  {
    label: "Cap. Funds / Dep. & ST Funding (%)",
    field: "cap_funds_dep_st_funding"
  },
  {
    label: "Cap. Funds / Liabilities (%)",
    field: "cap_funds_liabilities"
  },
  {
    label: "Subord Debt / Cap. Funds (%)",
    field: "subord_debt_cap_funds"
  }
]

export const OperationsRatiosYH = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Net Interest Margin (%)",
    field: "net_interest_margin"
  },
  {
    label: "Net Int. Rev. / Avg Assets (%)",
    field: "net_int_rev_avg_assets"
  },
  {
    label: "Oth. Op. Inc. / Avg Assets (%)",
    field: "oth_op_inc_avg_assets"
  },
  {
    label: "Non Int. Exp. / Avg Assets (%)",
    field: "non_int_exp_avg_assets"
  },
  {
    label: "Pre-Tax Op. Inc. / Avg Assets (%)",
    field: "pre_tax_op_inc_avg_assets"
  },
  {
    label: "Non Op. Items & Taxes / Avg Ast (%)",
    field: "non_op_items_taxes_avg_ast"
  },

  {
    label: "Return on Avg Assets (ROAA) (%)",
    field: "return_on_avg_assets_roaa"
  },
  {
    label: "Return on Avg Equity (ROAE) (%)",
    field: "return_on_avg_equity_roae"
  },
  {
    label: "Dividend Pay-Out (%)",
    field: "dividend_pay_out"
  },
  {
    label: "Inc. Net of Dist. / Avg Equity (%)",
    field: "inc_net_of_dist_avg_equity"
  },
  {
    label: "Non Op. Items / Net Income (%)",
    field: "non_op_items_net_income"
  },
  {
    label: "Cost to Income Ratio (%)",
    field: "cost_to_income_ratio"
  },
  {
    label: "Recurring Earning Power (%)",
    field: "recurring_earning_power"
  }
]

export const LiquidityRatiosYH = [
  {
    label: "Interbank Ratio (%)",
    field: "interbank_ratio"
  },
  {
    label: "Net Loans / Total assets (%)",
    field: "net_loans_total_assets"
  },
  {
    label: "Net Loans / Dep. & ST Funding (%)",
    field: "net_loans_dep_st_funding"
  },
  {
    label: "Net Loans / Tot. Dep. & Bor. (%)",
    field: "liquid_assets_tot_dep_bor"
  },
  {
    label: "Liquid Assets / Dep. & ST Funding (%)",
    field: "liquid_assets_dep_st_funding"
  },
  {
    label: "Liquid Assets / Tot. Dep. & Bor. (%)",
    field: "liquid_assets_tot_dep_bor"
  }
]

// 保险公司
export const ProfitabilityRatiosBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "ROE using P/L before tax (%)",
    field: "roe_using_p_l_before_tax"
  },
  {
    label: "Profit margin (%)",
    field: "profit_margin"
  },
  {
    label: "ROA using P/L before tax (%)",
    field: "roa_using_p_l_before_tax"
  }, {
    label: "Net Premiums / Gross Premiums (%)",
    field: "net_premiums_gross_premiums"
  },
  {
    label: "Investment Yield (%)",
    field: "investment_yield"
  }

]

export const StructureRatiosBX = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Solvency ratio (%)",
    field: "solvency_ratio"
  }, {
    label: "U/W Result / Net Investment Inc. (%)",
    field: "u_w_result_net_investment_inc"
  }
]

export default {
  employeesColumn,
  keyFinancialsColumn,
  globalAssetsColumn,
  equityColumn,
  profitColumn,
  memoColumn,
  // 
  globalAssetsColumnYH,
  equityColumnYH,
  profitColumnYH,
  memoColumnYH,
  // 
  // 
  globalAssetsColumnBX,
  equityColumnBX,
  profitColumnBX,
  memoColumnBX,
  // 
  incomeColumn,
  balanceColumn,
  cashFlowColumn,

  profitabilityColumn,
  operationalColumn,
  structureColumn,
  perEmployeeColumn,
  // 银行
  profitabilityColumnYH,
  CapitalRatiosYH,
  OperationsRatiosYH,
  LiquidityRatiosYH,
  // 
  ProfitabilityRatiosBX,
  StructureRatiosBX
}
